import { configureStore } from "@reduxjs/toolkit"

import { masterRecordsSlice } from "@/slice/masterRecordsSlice"
import { masterSchemaSlice } from "@/slice/masterSchemaSlice"
import { uiSlice } from "@/slice/uiSlice"

export const store = configureStore({
	reducer: {
		masterSchema: masterSchemaSlice.reducer,
		masterRecords: masterRecordsSlice.reducer,
		ui: uiSlice.reducer,
	},
})
export type RootState = ReturnType<typeof store.getState>
